<template>
    <div class="empty">
        <img :src="require('@/static/news/empty.png')" alt="" class="empty-img">
        <div class="empty-text">暂时还没有数据哦~·~</div>
    </div>
</template>
<script>
export default {
}
</script>
<style lang="scss" scoped>
.empty{
    width: 100%;
    height: 100%;
    padding-top: 100px;
    text-align: center;
    img{
      width: 200px;
      height: 200px;
    }
    .empty-text{
      font-size: 20px;
      color: #8A8A8A;
      margin-top: 20px;
    }
}
</style>
